import React from 'react';
import { COMPANY, ADDRESS_FULL } from '../../siteData';
import {
  FooterContainer,
  FooterWrap,
  FooterTop,
  FooterBrand,
  FooterLogo,
  FooterAddress,
  FooterEmail,
  FooterNav,
  FooterRouteLink,
  FooterScrollLink,
  FooterDivider,
  WebsiteRights,
} from './FooterElements';

// `scrollLinks` controls whether the section links scroll within the current
// page (home) or route the visitor back to the home page first (legal pages).
const Footer = ({ scrollLinks = true }) => {
  const year = new Date().getFullYear();

  const sections = [
    { to: 'services', label: 'Services' },
    { to: 'products', label: 'Products' },
    { to: 'about', label: 'About' },
    { to: 'contact', label: 'Contact' },
  ];

  const renderSectionLink = ({ to, label }) =>
    scrollLinks ? (
      <FooterScrollLink
        key={to}
        to={to}
        smooth={true}
        duration={500}
        spy={true}
        exact='true'
        offset={-80}
      >
        {label}
      </FooterScrollLink>
    ) : (
      <FooterRouteLink key={to} to='/'>
        {label}
      </FooterRouteLink>
    );

  return (
    <FooterContainer>
      <FooterWrap>
        <FooterTop>
          <FooterBrand>
            <FooterLogo to='/'>{COMPANY.legalName}</FooterLogo>
            <FooterAddress>
              {ADDRESS_FULL}
              <br />
              <FooterEmail href={`mailto:${COMPANY.email}`}>
                {COMPANY.email}
              </FooterEmail>
            </FooterAddress>
          </FooterBrand>
          <FooterNav>
            {sections.map(renderSectionLink)}
            <FooterRouteLink to='/privacy'>Privacy</FooterRouteLink>
            <FooterRouteLink to='/terms'>Terms</FooterRouteLink>
          </FooterNav>
        </FooterTop>
        <FooterDivider />
        <WebsiteRights>
          © {year} {COMPANY.legalName}. All rights reserved.
        </WebsiteRights>
      </FooterWrap>
    </FooterContainer>
  );
};

export default Footer;
